import { Component, Input, OnInit } from '@angular/core'

import { environment } from 'environments/environment'

import { Organization, Persona } from 'app/models'

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() public organization: Organization
  @Input() public title?: string
  @Input() public subtitle?: string
  @Input() public persona: Persona

  public profileUrl: string

  public ngOnInit(): void {
    if (!this.title) this.title = this.organization.name
    this.profileUrl = environment.mySeUrl
  }
}
